import styled from 'styled-components'

export const WebsiteLanguageSwitcherIconWrapperUi = styled.div`
  padding: 6px 8px;
`
